export default "__VITE_ASSET__DbRID68___"